/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

const CALENDAR_PROVIDER_GOOGLE = 'google'
const CALENDAR_PROVIDER_MICROSOFT = 'microsoft'

const SchedulingErrorTypes = {
  studyIsFull: 'range_taken',
  deadlinePassed: 'range_passed',
  sessionInvalid: 'range_invalid',
  participantRemoved: 'participant_removed',
  participantSubmitted: 'participant_submitted',
  participantPaid: 'participant_paid',
  participantExpired: 'participant_expired',
  participantQuotaGated: 'participant_quota_gated',
};

const EmailTags = {"SCHEDULE":"schedule","NEW_SESSIONS":"new-sessions","PANIC_BUTTON":"panic-button","REFERRAL":"referral"};

export {
  CALENDAR_PROVIDER_GOOGLE,
  CALENDAR_PROVIDER_MICROSOFT,
  EmailTags,
  SchedulingErrorTypes,
};
